import React, { useState } from 'react';
import { Subscription } from 'react-apollo';
import gql from 'graphql-tag';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';

const CURRENT_VERSION = process.env.REACT_APP_VERSION;

const QUERY = gql`
    subscription watchVersion {
        row: settings_by_pk(key: "APP_VERSION") {
            value
            key
        }
    }
`;

const UpdateNotification = ({ }) => {
  const [hideDialog, setHideDialog] = useState(false);

  return (
    <Subscription subscription={QUERY}>
      {({ data }) => {

        if (hideDialog || !data) return null;
        const { row } = data;

        console.log(CURRENT_VERSION, row.value);

        if (row.value === CURRENT_VERSION) return null;

          return (
            <Dialog open>
              <DialogTitle>
                App Update Available
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  There is a new version of the app available. Please reload the page to get the latest version.
                  It is advisable to update the app to avoid any issues.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setHideDialog(true)}>Update Later</Button>
                <Button variant="contained" color="primary" onClick={() => window.location.reload()}>Update Now</Button>
              </DialogActions>
            </Dialog>
          )
      }}
    </Subscription>
  )
};

export default UpdateNotification;
